import React, { useState, useEffect } from "react";
import Header from "../Components/ProductSalesReport/Header";
import ProductSalesReportOverview from "../Components/ProductSalesReport/ProductSalesReportOverview";
import { getProductSalesReport } from "../actions/ProductSalesReportAction";
import { getProductSalesReports } from "../services/productSalesReportService";
import { getDistributorNames } from "../Common/functions";

const ProductSalesReport = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
    const [filters, setFilters] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  function getTotalPages(totalItems, itemsPerPage) {
    if (itemsPerPage <= 0) return 0; // avoid division by zero
    return Math.ceil(totalItems / itemsPerPage);
  }

const getApplicationReport1 = async () => {
  setData([]);
  setLoading(true);

  try {
    const result = await getProductSalesReports({
      category: "sales tracking",
      tracking_status: "Sale",
      page_size: itemsPerPage,
      page_number: currentPage,
      start_date: filters.fromDate,
      end_date: filters.toDate,
      search_term: searchTerm,
      // distributor_name:
      //   userRole === "super_admin" || userRole === "manager"
      //     ? filters.distributorName
      //     : getDistributorNames()[0],
      // doctorsname: filters.doctorName,
      // group_title: filters.chooseTeam,

      // group_title: "Distributor",
      // UserId: "e821a3d0-9061-70d5-2953-99f1a9ba36b8",
      distributor_name: getDistributorNames()[0]
    });

    if (result?.data) {
      setData(result.data.items);
      setCurrentPage(result.data.current_page);
      setTotalCount(result.data.total_records);
      setTotalPages(getTotalPages(result.data.total_records, itemsPerPage));
    } else {
      console.error("Unexpected response format:", result);
    }
  } catch (error) {
    console.error("Error fetching product sales reports:", error);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    } else {
      getApplicationReport1();
    }
  }, [searchTerm]);
    
  useEffect(() => {
    getApplicationReport1();
  }, [itemsPerPage, currentPage, filters]);

  return (
    <div className="space-y-10">
      <Header />
      <ProductSalesReportOverview
        data={data}
        loading={loading}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        setCurrentPage={setCurrentPage}
        setSearchTerm={setSearchTerm}
        setFilters={setFilters}
        setItemsPerPage={setItemsPerPage}
        itemsPerPage={itemsPerPage}
      />
    </div>
  );
};

export default ProductSalesReport;
